export function AnnouncementsPanel({ data }) {
  const { announcements = [] } = data

  const pinned = announcements.find((a) => a.is_pinned)
  const shown  = pinned ?? announcements[0] ?? null

  if (!shown) return null // panel skipped in rotation when no announcements

  const posted = new Date(shown.created_at).toLocaleDateString('en-US', {
    month: 'long', day: 'numeric', year: 'numeric',
  })
  const authorName = shown.profiles?.display_name ?? 'Unknown'

  return (
    <div className="flex flex-col h-full px-4 sm:px-8 py-4 sm:py-6 panel-animate-in">
      <p className="text-gray-500 text-xs sm:text-sm font-semibold uppercase tracking-widest mb-2">
        {pinned ? '📌 Pinned' : '📢 Announcement'}
      </p>

      <div className="flex-1 flex flex-col justify-center max-w-3xl mx-auto w-full overflow-y-auto scrollbar-hide">
        <h2 className="text-xl sm:text-3xl font-bold text-white mb-3 sm:mb-6 leading-tight">{shown.title}</h2>
        <p className="text-gray-300 text-base sm:text-xl leading-relaxed whitespace-pre-line">{shown.body}</p>
        <p className="mt-4 sm:mt-8 text-gray-500 text-xs sm:text-sm">
          Posted by {authorName} · {posted}
        </p>
      </div>
    </div>
  )
}
